<template>
  <div :class="{ 'dea-school-selection--checked': isChecked }" class="dea-school-selection">
    <div class="dea-school-selection__school-data">
      <div class="dea-school-selection__checkbox-container">
        <Checkbox
          v-if="checkType == 'checkbox'"
          :id="id"
          :name="checkName"
          class="dea-school-selection__checkbox"
          :checked="isChecked"
          @click="isChecked = !isChecked"
        ></Checkbox>
        <RadioButton
          v-if="checkType == 'radio'"
          :id="id"
          :name="checkName"
          class="dea-school-selection__checkbox"
          :checked="checked"
          :value="value"
          @change="handleInput"
        ></RadioButton>
      </div>
      <SchoolData :name="name" :code="code" :address="address" :label="label" />
    </div>
    <div v-if="showEditLink" class="dea-school-selection__cta-container">
      <Links href="#" class-name="dea-links dea-links--target-color-blue-docenti dea-links--large">Modifica</Links>
    </div>
  </div>
</template>

<script>
import Checkbox from "../elements/Checkbox";
import Links from "../elements/Links";
import RadioButton from "../elements/RadioButton";
import SchoolData from "../elements/SchoolData";

export default {
  name: "SchoolRadio",
  components: { Checkbox, Links, RadioButton, SchoolData },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    checkType: {
      type: String,
      default: "checkbox",
      validator: value => {
        return ["checkbox", "radio"].indexOf(value) !== -1;
      },
    },
    checkName: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    showEditLink: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    checked() {
      this.isChecked = this.checked;
    },
  },
  methods: {
    handleInput(event) {
      this.$emit("change", event);
    },
  },
};
</script>

<style lang="scss"></style>
